<!--
	消息中心
	lovi 2020-1-3
-->
<template>
  <div>
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("personal.messageCenter") }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="list-wrap" v-if="listData.length">
      <div class="item-list" v-for="(item, index) in listData" :key="index">
        <h3>
          <span @click="changeDetails(item, index)">{{ item.title }}</span>
        </h3>
        <p :class="[detailFlag == item.id ? 'show-details' : 'hide-details']">
          {{ item.content }}
        </p>
      </div>
      <div class="page-wrap">
        <Page @on-change="_getPage(page)" :current.sync="page" size="small" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "personal-msgCenter",
  data() {
    return {
      page: 1,
      listData: [],
      detailFlag: ""
    };
  },
  created() {
    this.getNotice();
  },
  mounted() {},
  computed: {},
  methods: {
    _getPage(page) {
      let vm = this;
      vm.page = page;
      vm.getNotice();
    },
    changeDetails(data, index) {
      let vm = this;
      if (data.read_status == "") {
        vm.toDetail(data.id, index);
      }
      if (vm.detailFlag == data.id) {
        vm.detailFlag = null;
      } else {
        vm.detailFlag = data.id;
      }
    },
    toDetail(id, index) {
      //详情
      let vm = this;
      let params = {};
      params.type = 3;
      params.id = id;
      vm.$post("/app/index/notice", params, { loading: true }).then(res => {
        console.log("notice", res);
        if (typeof index == "number") {
          vm.$set(vm.listData[index], "read_status", 1);
          console.log("listData", vm.listData);
        }
      });
    },
    getNotice() {
      let vm = this;
      let params = {};
      params.page = vm.page;
      params.type = 1;
      vm.$post("/app/index/notice", params, { loading: true }).then(res => {
        console.log(res, "notice");
        vm.listData = res;
      });
    }
  },
  watch: {},
  components: {},
  deactivated() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.list-wrap {
  padding: 20px 50px;
  .item-list {
    padding: 15px 0;
    border-bottom: 1px solid #ccc;
    line-height: 1;
    h3 {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 500;
      span {
        cursor: pointer;
      }
    }
    p {
      font-size: 14px;
      height: auto;
      line-height: 24px;
      color: #666;
      transition: all 0.5s;
      &.hide-details {
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

.page-wrap {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
